import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteProduct } from '../../api/apiProducts';
import { toast } from 'react-hot-toast';
import parseError from '../../utils/parseError';

/**
 * Hook to delete a product (Soft delete)
 */
export const useDeleteProduct = () => {
    const queryClient = useQueryClient();

    const { mutate: removeProduct, isPending: isDeleting } = useMutation({
        mutationFn: deleteProduct,
        onSuccess: (res) => {
            queryClient.invalidateQueries({ queryKey: ['products'] });
            toast.success(res?.data?.message || res?.message);
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message);
        }
    });

    return { removeProduct, isDeleting };
};
